import React from 'react';
import { ArrowUp } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-[var(--site-ink)] text-white relative">
      {/* 回到顶部按钮 */}
      <button
        onClick={scrollToTop}
        aria-label="Back to top / 返回顶部"
        className="absolute -top-6 right-8 bg-stone-700 hover:bg-stone-600 text-white p-3 rounded-full shadow-lg transform hover:scale-110 transition-all duration-300 z-10"
      >
        <ArrowUp className="w-5 h-5" />
      </button>

      {/* 主要内容区 */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="text-center">
          <Link to="/" className="inline-flex items-center gap-3 mb-6 text-left">
            <img src="/images/logo.jpg" alt="大师兄 Logo" width="44" height="44" className="rounded-full" />
            <span><strong className="block text-base text-white">AI 大师兄</strong><span className="text-xs text-stone-400">AI 订阅 · 广告投放 · 一切代充</span></span>
          </Link>
          {/* 底部链接 */}
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 mb-6 text-sm">
            <Link to="/terms" className="text-stone-300 hover:text-white transition-colors">
              Terms of Service / 服务条款
            </Link>
            <Link to="/privacy" className="text-stone-300 hover:text-white transition-colors">
              Privacy Policy / 隐私政策
            </Link>
            <Link to="/disclaimer" className="text-stone-300 hover:text-white transition-colors">
              Disclaimer / 免责声明
            </Link>
          </div>

          {/* 公司及法律信息 */}
          <div className="space-y-2 text-sm leading-6 text-stone-300">
            <p>&copy; 2024-2026 GetPro. All rights reserved. / 版权所有</p>
            <p>
              <span className="text-stone-400">Operating Entity / 运营主体:</span>{' '}
              <span className="font-medium text-stone-200">NOUVIX PTE. LTD.</span>
            </p>
            <address className="not-italic">
              <span className="text-stone-400">Registered Address / 注册地址:</span>{' '}
              3 PHILLIP STREET, #10-04 ROYAL GROUP BUILDING, SINGAPORE 048693
              <span className="block">新加坡菲利普街 3 号皇家集团大厦 #10-04，邮编 048693</span>
            </address>
          </div>

          <div className="mt-7 grid gap-5 border-t border-stone-700 pt-6 text-left text-xs leading-5 text-stone-400 md:grid-cols-2 md:gap-8">
            <section lang="en" aria-labelledby="legal-notice-en">
              <h2 id="legal-notice-en" className="mb-2 font-semibold text-stone-300">
                Important Legal Notice
              </h2>
              <p>
                This website is an independent third-party service platform. It is not the official
                website of ChatGPT or OpenAI and has no official authorization, agency, partnership,
                endorsement, affiliation, or other relationship with OpenAI or ChatGPT. Any related
                names appearing on this website are used solely to identify the services concerned.
                This website should not be regarded as an official OpenAI or ChatGPT channel.
              </p>
            </section>

            <section lang="zh-CN" aria-labelledby="legal-notice-zh">
              <h2 id="legal-notice-zh" className="mb-2 font-semibold text-stone-300">
                重要法律声明
              </h2>
              <p>
                本站为独立第三方服务平台，并非 ChatGPT 或 OpenAI 官方网站，与 OpenAI 或 ChatGPT
                不存在任何官方授权、代理、合作、背书、隶属或其他关系。本站出现的相关名称仅用于说明服务对象，
                请勿将本站理解为 OpenAI 或 ChatGPT 官方渠道。
              </p>
            </section>
          </div>
        </div>
      </div>
    </footer>
  );
}
